import React from "react";

const StarRating = ({ rating }) => {
  const totalStars = 5;

  return (
    <div className="star-rating">
      {[...Array(totalStars)].map((_, index) => (
        <span
          key={index}
          className={`starW ${index < rating ? "filledG" : "empty"}`}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;
